import * as api from "$helper/api";

export function purchase(requestObj: any): Promise<any> {
    return api.send<any, any>("https://sbpaymentservices.payfort.com/FortAPI/paymentApi", "POST", requestObj);
}

export const payforthService = {
    purchase,
};
